/**
 * Helpdesk wire shapes as the web reads them — `@seagames/contracts`
 * (helpdesk.ts), re-exported so the components keep one import.
 */
import type { HelpdeskTicketDetail, HelpdeskTicketListItem, ListHelpdeskTicketsQueryInput } from "@seagames/contracts";

export type {
	AddHelpdeskNoteBody,
	CreateHelpdeskTicketBody,
	HelpdeskCategory,
	HelpdeskNote,
	HelpdeskPriority,
	HelpdeskSource,
	HelpdeskStatus,
	HelpdeskTicketDetail,
	PatchHelpdeskTicketBody,
} from "@seagames/contracts";

export type HelpdeskTicketRow = HelpdeskTicketListItem;

export interface HelpdeskTicketsPage {
	items: HelpdeskTicketRow[];
	next_cursor: string | null;
	/** First page only (a scalar count in the same statement). */
	total: number | null;
}

/** `GET /helpdesk/tickets` filters, wire form (`status` / `priority` / `category` are comma lists). */
export type HelpdeskTicketsFilter = Omit<ListHelpdeskTicketsQueryInput, "status" | "priority" | "category"> & {
	status?: string;
	priority?: string;
	category?: string;
};

/** May this viewer work the ticket (status, notes, priority)? The detail's `can_handle` (`ticketWritable`). */
export const canWorkTicket = (t: HelpdeskTicketDetail): boolean => t.can_handle;
